<template>
    <div class="p-3">
        <b-card
            :title="'Edit Konfigurasi Loket Pendaftaran Online - ' + metode_pendaftaran.nama"
        >
            <b-card-text>
                <b-button variant="danger" class="mt-5" @click="cancelEdit">Kembali</b-button>

                <form class="mt-5">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-nama">Tambah Loket Pendaftaran</label>
                        <div class="col-lg-6">
                            <select2 id="select-poli" v-model="form.loket_pendaftaran" :options="all_loket_pendaftaran_options" @change="addLoketPendaftaran"></select2>
                        </div>
                    </div>
                </form>

                <div id="tabledata-metode-pendaftaran" class="mt-3"></div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    props: ['id'],
    components: {
        Select2
    },
    data() {
        return {
            user: null,
            form: {
                metode_pendaftaran: 0,
                loket_pendaftaran: 0,
            },
            metode_pendaftaran: {
                id: 0,
                nama: '',
            },
            table_metode_pendaftaran: null,
            all_loket_pendaftaran_options: [{id: 0, text: '--- Pilih Loket Pendaftaran ---'}]
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getMetodePendaftaran()
            this.getLoketPendaftaran()
        },
        getMetodePendaftaran() {
            this.$isLoading(true)
            let uri = '/api/get_metode_pendaftaran?id=' + this.id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }
            
            this.axios.get(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    this.metode_pendaftaran = {
                        id: response.data.metode_pendaftaran.id,
                        nama: response.data.metode_pendaftaran.nama,
                    }

                    this.form.metode_pendaftaran = response.data.metode_pendaftaran.id

                    let penunjang = function (cell, formatterParams) {
                        let data = cell.getRow().getData()

                        return data.loket_pendaftaran.penunjang == 1 ? 'Ya' : 'Tidak'
                    }

                    let actions = function (cell, formatterParams) {
                        return '<button id="delete" class="btn btn-danger btn-sm"><i id="delete" class="fa fa-trash" aria-hidden="true"></i> delete</button>'
                    }

                    this.table_metode_pendaftaran = new Tabulator('#tabledata-metode-pendaftaran', {
                        layout: 'fitColumns',
                        data: response.data.metode_pendaftaran.konfigurasi_loket,
                        columns:[
                            {title: 'Nama', field: 'loket_pendaftaran.nama'},
                            {title: 'Prefix', field: 'loket_pendaftaran.prefix'},
                            {title: 'Nomor Loket', field: 'loket_pendaftaran.nomor_loket'},
                            {title: 'Penunjang', formatter: penunjang},
                            {title: 'Aksi', field: 'aksi', formatter: actions, headerSort: false, cellClick: this.actionButton}
                        ]
                    })
                }

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        getLoketPendaftaran() {
            this.$isLoading(true)
            let uri = '/api/konf_loket_pendaftaran'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }
            
            this.axios.get(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    this.all_loket_pendaftaran_options = [{id: 0, text: '--- Pilih Loket Pendaftaran ---'}]

                    let loket_pendaftaran = response.data.loket_pendaftaran
                    loket_pendaftaran.forEach(lp => {
                        this.all_loket_pendaftaran_options.push({id: lp.id, text: 'nama: ' + lp.nama + ', prefix: ' + lp.prefix + ', nomor_loket: ' + lp.nomor_loket })
                    });
                }

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        actionButton(e, cell) {
            this.$swal.fire({
                title: 'Perhatian! ',
                text: 'Data akan dihapus. Yakin?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, hapus!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.isConfirmed) {
                    let data = cell.getRow().getData()
                    let metode_pendaftaran_id = data.metode_pendaftaran_id
                    let loket_pendaftaran_id = data.loket_pendaftaran_id

                    this.deleteLoketPendaftaranFromMetodePendaftaran(metode_pendaftaran_id, loket_pendaftaran_id)
                }
            }).catch((error) => {
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        deleteLoketPendaftaranFromMetodePendaftaran(metode_pendaftaran_id, loket_pendaftaran_id) {
            this.$isLoading(true)
            let uri = '/api/delete_loket_pendaftaran_to_metode_pendaftaran'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, {
                metode_pendaftaran_id: metode_pendaftaran_id,
                loket_pendaftaran_id: loket_pendaftaran_id
            }, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Data Berhasil Dihapus!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                    this.getMetodePendaftaran()
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }

                this.$isLoading(false)
            })
        },
        addLoketPendaftaran() {
            this.$isLoading(true)
            let uri = '/api/add_loket_pendaftaran_to_metode_pendaftaran'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }
            
            this.axios.post(uri, this.form, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Data Berhasil Dibuat!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                    this.getMetodePendaftaran()
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
                this.$isLoading(false)
            })
        },
        cancelEdit() {
            this.$router.push('konfigurasi-loket-pendaftaran-online')
        }
    }
}
</script>
